<script setup lang="ts">
import { worksByGenre } from '~/queries/work'
import groupBy from '../../../utils/groupBy'

const { locale } = useI18n()

const { slug } = useResourceSlug()
const { data, pending, error } = await useAsyncData(`/work/genre/${slug}`, () =>
  execQuery(worksByGenre, { slug })
)

function formatWork(work) {
  const composers = work.composers
  let excerpt: string
  if (composers && composers.length > 0) {
    excerpt = composers
      .map(({ firstName, lastName }) => `${firstName} ${lastName}`)
      .join(', ')
  }
  return {
    ...work,
    type: 'work',
    excerpt,
  }
}
const works = computed(() => {
  if (pending.value || error.value) return []
  return data.value.data.worksByGenre.worksGroupBy
})

const title = computed(() => {
  if (pending.value || error.value) return []
  const { title, titleEn } = data.value.data.worksByGenre
  return { title, titleEn }
})

const initialValue = computed(() => {
  if (pending.value || error.value) return null
  return works.value[0].works
})

const result = ref(null)
const selected = ref(works.value[0].label)

function getClasses(label) {
  let res =
    'p-2 border-solid border-2 border-gray-300 transition-colors duration-200 ease-in-out hover:!border-primary-400 hover:text-primary-400'
  if (label === selected.value) {
    res += ' bg-primary-400'
  }
  return res
}

const handlePagination = (label) => {
  selected.value = label
  const selectedItem = works.value.find((item) => item.label === label)

  if (selectedItem) {
    const works = selectedItem.works
    result.value = works
  }
}
</script>

<template>
  <div class="mx-auto mt-4 w-10/12">
    <h2 v-if="locale === 'fr'" class="text-mobile-xl lg:text-xl">
      {{ title.title }}
    </h2>
    <h2 v-else class="text-mobile-xl lg:text-xl">{{ title.titleEn }}</h2>
    <hr />
    <div class="pagination-buttons mt-4">
      <button v-for="item in works" :key="item.label" :class="getClasses(item.label)"
        @click="handlePagination(item.label)">
        {{ item.label }}
      </button>
    </div>
    <div class="mt-5">
      <div v-for="[orderField, values] in groupBy(
        result ?? initialValue,
        ({ orderField }) => orderField,
        {
          asList: true,
        }
      )">
        <div class="mb-2 flex items-baseline">
          <h2 class="text-xl font-bold">
            {{ orderField }}
          </h2>
          <span class="ml-2 rounded-xl bg-primary-400 px-2 py-1">{{
            values.length
            }}</span>
        </div>
        <hr />
        <ListResource v-for="(value, i) in values.map(formatWork)" :key="i" :resource="value"
          class="ml-4 py-4 first:mt-4 md:p-4 md:first:mt-0" />
      </div>
    </div>
  </div>
</template>
